// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { spacerStyles } from "@synd/App/Widgets/Basic/Spacer";
import BrandedSmallRosebud from "@synd/XDL/Icons/BrandedSmallRosebud";
import { color } from "@synd/XDL/Utilities";
import { css } from "styled-components";

spacerStyles.spacerElement = {
    css: css`
        ${({ padding }: any) => css`
            padding: ${padding}px 0;
        `}
        display: flex;
        flex-direction: column;
        justify-content: center;

        ${({ horizontalRule }: any) =>
            horizontalRule &&
            css`
                position: relative;
                &:after {
                    content: "";
                    display: block;
                    width: 100%;
                    ${({ hrHeight }: any) => css`
                        height: ${hrHeight}px;
                    `}
                    ${({ hrColor }: any) => css`
                        background-color: ${hrColor};
                        ${({ extendRule }: any) =>
                            extendRule &&
                            css`
                                box-shadow: 0 0 0 100vmax ${hrColor};
                                clip-path: inset(0 -100vmax);
                            `}
                    `}
                }
            `}
    `,
};

spacerStyles.wrapper = {
    css: css`
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        & [data-test-selector="spacer-widget"] {
            flex: 1;
        }
    `,
};

spacerStyles.iconWrapper = {
    css: css`
        background: ${color("common.white")};
        padding: 0 8px;
        z-index: 1;
        display: flex;
        justify-content: center;
        align-items: center;
    `,
};

spacerStyles.icon = {
    src: BrandedSmallRosebud,
    width: 17,
    height: 15,
    color: "primary",
} as any;
